import { useCallback } from "react";
import { getSearchInteractionId } from "../../analytics/interactions";
import { getSessionId } from "../../analytics/sessions";
import { getOnPageValue } from "../../analytics/track";
import { getVisitorId } from "../../analytics/visitors";
import { useConfig } from "../../providers/config_provider";
import {
  WebSocketAction,
  WebSocketChannel,
  type WebSocketMessage,
  useWebSocket,
} from "../../providers/web_sockets_provider";

export function useConversationsAPI() {
  const { submitRequest, clearRequest } = useWebSocket();
  const { apiToken, sessionToken } = useConfig();

  const conversationsCreate = useCallback(
    (query: string, onMessageReceived: (data: WebSocketMessage) => void) => {
      submitRequest(WebSocketChannel.Conversations, WebSocketAction.Create, query, onMessageReceived, {
        query,
        token: apiToken,
        session_token: sessionToken,
        client_timestamp: Date.now(),
        session_id: getSessionId(),
        visitor_id: getVisitorId(),
        on_page: getOnPageValue(),
        search_interaction_id: getSearchInteractionId(),
      });
    },
    [submitRequest, apiToken, sessionToken],
  );

  const conversationsCancel = useCallback(
    (query: string) => {
      // Stop listening for the active query
      clearRequest(WebSocketChannel.Conversations, WebSocketAction.Create, query);

      const clientTimestamp = Date.now();
      submitRequest(
        WebSocketChannel.Conversations,
        WebSocketAction.Cancel,
        clientTimestamp.toString(),
        () => {},
        {
          client_triggered_at: clientTimestamp,
        },
        { queueable: false },
      );
    },
    [submitRequest, clearRequest],
  );

  return {
    conversationsCreate,
    conversationsCancel,
  };
}
